module.exports = __webpack_public_path__ + "9a5ddd51723d6b92c118a4670ed910c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-penguin-got-it.png
// module id = 2025
// module chunks = 4